import React from 'react';
import PropTypes from 'prop-types';

const Total = (props) => (
    <div key="score" className="badge-score">
        <em>{props.amount}</em>{props.symbol}
        <div className='badge-subtitle'>{props.title}</div>
    </div>
);

Total.propTypes = {
    amount: PropTypes.number.isRequired,
    symbol: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string
};

Total.defaultProps = {
    title: '',
    symbol: ''
};


export default Total;

